import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { size, toArray } from 'lodash';
import PropTypes from 'prop-types';

import { uploadFile } from '../../../../../actions/CM/cm_close_loop/scenarioCarMakerFileUpload/uploadFileEnhanced';
import UploadItem from '../uploadItem/uploadItem';
import Styles from './uploadProgress.module.css';

const UploadProgress = props => {
    const { fileProgress, uploadFile } = props;
    const uploadFileAmount = size(fileProgress)

    useEffect(() => {
        const fileToUpload = toArray(fileProgress).filter(file => file.progress === 0);
        uploadFile(fileToUpload)
    }, [uploadFileAmount])

    return uploadFileAmount > 0 ? (
        <div className={Styles.wrapper}>
            <h4>Uploading File</h4>
            {size(fileProgress)
                ? toArray(fileProgress).map(file => <UploadItem key={file.id} file={file}/>)
                : null
            }
        </div>
    ) : null
}

// Prop Validation.
UploadProgress.propTypes = {
    fileProgress: PropTypes.object,
    uploadFile: PropTypes.func
}

const mapStateToProps = state => ({
    fileProgress: state.cmUploadFileEnhanced.fileProgress,
})

const mapDispatchToProps = dispatch => ({
    uploadFile: files => dispatch(uploadFile(files)),
})

export default connect(mapStateToProps, mapDispatchToProps)(UploadProgress);